var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/logo.jpg"),"height":_vm.height + 'px'}})
}
var staticRenderFns = []

export { render, staticRenderFns }